import { getUserTeam } from "../../../../util";
import queues_logo_gray from "../../../../assets/queues_logo_gray.png"

export const loadLibraries = async (setProgressMessage) => {
  setProgressMessage('Loading PDF libraries...');
  if (typeof window.jspdf === 'undefined') {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  if (typeof window.html2canvas === 'undefined') {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
};

// The S3 logo (logoURL) first, then the bundled file at logoPath. Null when neither loads.
export const loadLogoImage = async (logoPath, logoURL) => {
  if (logoURL) {
    const fromUrl = await fetchAsDataURL(logoURL);
    if (fromUrl) return fromUrl;
  }
  if (!logoPath) return null;
  let bundled;
  try {
    bundled = require(`../../../../clients/${logoPath}`);
  } catch (error) {
    return null;
  }
  return fetchAsDataURL(bundled);
};

const fetchAsDataURL = async (logoUrl) => {
  try {
    const response = await fetch(logoUrl);
    if (!response.ok) return null;
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error loading logo:', error);
    return null;
  }
};

export const loadTeamLogo = async (league, venue) => {
  try {
    const teamInfo = getUserTeam(league, venue);
    if (teamInfo && teamInfo.imgURL) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width || 300;
          canvas.height = img.height || 300;
          const ctx = canvas.getContext('2d');
          ctx.fillStyle = 'white';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          try {
            const dataUrl = canvas.toDataURL('image/png');
            resolve(dataUrl);
          } catch (error) {
            console.error('Error converting team logo to data URL:', error);
            reject(error);
          }
        };
        img.onerror = (error) => {
          console.error('Error loading team logo image:', error);
          reject(error);
        };
        img.src = teamInfo.imgURL;
      });
    }
    return null;
  } catch (error) {
    console.error('Error loading team logo:', error);
    return null;
  }
};

export const checkPageBreak = (pdf, yPos, margin, requiredSpace) => {
    const pageHeight = pdf.internal.pageSize.getHeight();
    if (yPos + requiredSpace > pageHeight - margin) {
      pdf.addPage();
      return margin;
    }
    return yPos;
  };
  
  export const addPageFooters = (pdf, locationName, reportDate) => {
    const totalPages = pdf.internal.getNumberOfPages();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    
    // Dont include footer on first title page
    for (let i = 2; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(128, 128, 128);
    
        const footerText = `Page ${i} of ${totalPages} | ${locationName} |`;
        const textWidth = pdf.getTextWidth(footerText);
        
        // Logo dimensions
        const logoWidth = 14;
        const logoProps = pdf.getImageProperties(queues_logo_gray);
        const logoHeight = (logoWidth * logoProps.height) / logoProps.width;
        const spacing = 2; // space between text and logo
        
        // Calculate total width of text + spacing + logo
        const totalWidth = textWidth + spacing + logoWidth;
        
        // Center the entire footer (text + logo) on the page
        const startX = (pageWidth - totalWidth) / 2;
        const yPos = pageHeight - 10;
        
        // Draw footer text
        pdf.text(footerText, startX, yPos);
        
        // Add logo right after the text
        const logoX = startX + textWidth + spacing;
        const logoY = yPos - logoHeight + 1.6; // align with text baseline
        
        pdf.addImage(queues_logo_gray, 'PNG', logoX, logoY, logoWidth, logoHeight);
    }
};